import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../../components/Loader'
import { useUploadHeader } from '../../../hooks/CompanyConfiguration/useUploadHeader'
import AddUploadHeader from './AddUploadHeader'

export default function EditUploadHeader() {
  const { uploadHeader, getUploadHeader } = useUploadHeader()
  console.log('CHECK : ', uploadHeader)
  const params = useParams()
  useEffect(() => {
    getUploadHeader({ _id: params.uploadHeaderId })
  }, [params.uploadHeaderId])

  return <> {uploadHeader ? <AddUploadHeader uploadHeader={uploadHeader} /> : <Loader />} </>
}
